import React, { useEffect, useRef, useState } from "react";
import _constantUtil from "../../../utils/Constant";
import Loader from "../../partial/Loader";
import {
    MdOutlineFileDownload,
    MdKeyboardArrowLeft,
    MdKeyboardDoubleArrowRight, 
    MdAdd, 
    MdAssignment,  
} from "react-icons/md"; 
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip"; 

function Bets() {
    const navigate = useNavigate() 
    const [selectedCards, setSelectedCards] = useState([]); 
    const [selectAllChecked, setSelectAllChecked] = useState(_constantUtil.BOOLEAN_FALSE); 
    const [showPublish, setShowPublish] = useState(_constantUtil.BOOLEAN_FALSE);
    const [assignBets, setAssignBets] = useState(_constantUtil.BOOLEAN_FALSE);
 
    const confirmationRef = useRef(_constantUtil.NULL);
    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (
                confirmationRef.current &&
                !confirmationRef.current.contains(event.target)
            ) {
                setAssignBets(false)
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
 
 
    return (
        <> 

            {assignBets && (
                <div>
                    <div className="confirmation-overlay"></div>
                    <div ref={confirmationRef} className="confirmation-dialog">
                        <p>Are you sure to assign bet ?</p>
                        <div className="d-flex justify-content-end ">
                            <button
                                onClick={() =>
                                    setAssignBets(
                                        _constantUtil.BOOLEAN_FALSE
                                    )
                                }
                                className="border-0 rounded px-3 bg-danger text-white p-2"
                            >
                                Cancel
                            </button>
                            <button 
                                className="border-0 rounded px-3 bg-success text-white p-2" 
                            >
                                Confirm 
                            </button>
                        </div>
                    </div>
                </div>
            )} 
 

            {showPublish && (
                <div>
                    <div className="confirmation-overlay"></div>
                    <div ref={confirmationRef} className="confirmation-dialog">
                        <p>Are you sure to Publish Bet ?</p>
                        <div className="d-flex justify-content-end ">
                            <button
                                onClick={() =>
                                    setShowPublish(
                                        _constantUtil.BOOLEAN_FALSE
                                    )
                                }
                                className="border-0 rounded px-3 bg-danger text-white p-2"
                            >
                                Cancel
                            </button>
                            <button 
                                className="border-0 rounded px-3 bg-success text-white p-2" 
                            >
                                Confirm 
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="px-4 ">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-between ">
                            <h4 className="header-title pb-3 text-muted mt-4"> 
                                <Link
                                    onClick={() => navigate(-1)}
                                    className="header-sub-title"
                                >
                                    Upcoming Match
                                </Link>
                                <span className="blr-player-view">
                                    <MdKeyboardDoubleArrowRight className="jumbo-red-text mb-1 ms-2 " />
                                </span>{" "}
                                All Bets
                            </h4>
                            <div className="d-flex align-items-center  my-3">
                                <MdAssignment 
                                    data-tooltip-id="assignbet"
                                    data-tooltip-content="Assign Bets"
                                    className="fs-4 me-2 b-1 jumbo-icon import-match-icon"
                                    onClick={() => setAssignBets(true)}
                                    />
                                <Tooltip
                                    border={false}
                                    id="assignbet"
                                    place="bottom"
                                    effect="solid"
                                    style={{ zIndex: "1000000" }}
                                />

                                <MdOutlineFileDownload
                                    data-tooltip-id="filedownload"
                                    data-tooltip-content="Import Bets" 
                                    className="fs-4 me-2 b-1 jumbo-icon import-match-icon"
                                />
                                <Tooltip
                                    border={false}
                                    id="filedownload"
                                    place="bottom"
                                    effect="solid"
                                    style={{ zIndex: "1000000" }}
                                />
                                <button
                                    type="button"
                                    className="btn text-white d-flex"
                                    style={{ float: "right" }}
                                    onClick={() => navigate(-1)}
                                >
                                    <MdKeyboardArrowLeft className=" fs-4" />
                                    Back
                                </button>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className={`card bets-light-background`}>
                                <div className="card-body"> 
                                    <> 
                                        <div
                                            className="card mb-4"  
                                        >
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table w-100 mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>SN</th>
                                                                <th>Category</th>
                                                                <th>Question Type</th>
                                                                <th>State</th>
                                                                <th className="text-nowrap">Option Type</th>
                                                                <th>Result</th>
                                                                <th>Status</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                            <tbody> 
                                                                <tr>
                                                                <td>1</td>
                                                                <td>1x2</td>
                                                                <td>match win</td>
                                                                <td>
                                                                    <span className="badge badge-info-lighten"> 
                                                                        INREVIEW
                                                                    </span>
                                                                </td>
                                                                <td>team a / team b</td>
                                                                <td>
                                                                    <span className="badge badge-warning-lighten"> 
                                                                        instant
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className="badge badge-success-lighten"> 
                                                                        ACTIVE
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-center"> 

                                                                        <button
                                                                            type="button"
                                                                            data-tooltip-id="publish"
                                                                            data-tooltip-content="Publish Bet"
                                                                            className="btn bg-primary text-white d-flex me-2 py-0 px-1 fs-6"
                                                                            style={{ float: "right" }} 
                                                                        >
                                                                            Publish
                                                                        </button>
                                                                        <Tooltip
                                                                            id="publish"
                                                                            place="bottom"
                                                                            effect="solid"
                                                                        />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                
                                                <div className="mt-3">
                                                    <div className="mb-3">
                                                        <strong> Question :{" "}</strong>
                                                        <span>
                                                            Who will win the match ? 
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="row d-flex align-items-center justify-content-center">
                                                    {/* option one */}
                                                    <div className="col-12 col-md-6 mb-2">
                                                        <div className="card w-100 bets-responsive">
                                                            <div className="card-body">
                                                                <div className="d-flex align-items-center justify-content-around">
                                                                    <h5 className="text-center mb-3">
                                                                        Option 
                                                                        (India) 
                                                                    </h5>
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-around"
                                                                    style={{ border: "1px solid var(--bs-border-color)", borderBottom:'0px' }} >
                                                                    <h6 className="w-25 text-center m-0 p-2"  style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                        Rate ( ROI )
                                                                    </h6>
                                                                    <h6 className="w-25 text-center m-0 p-2" style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                        Count
                                                                    </h6>
                                                                    <h6  className="w-25 text-center m-0 p-2"  style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                        Amount
                                                                    </h6>
                                                                    <h6 className="w-25 text-center m-0 p-2">
                                                                        Percentage
                                                                    </h6>
                                                                </div>

                                                                <div className="d-flex align-items-center justify-content-around"
                                                                    style={{ border: "1px solid var(--bs-border-color)", }} >

                                                                    <div className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        <span className="badge badge-danger-lighten">2.2</span>
                                                                    </div>

                                                                    <div className="w-25 text-center m-0 p-2"
                                                                        style={{borderRight:"1px solid var(--bs-border-color"}}
                                                                        >
                                                                        <span className="badge badge-primary-lighten"
                                                                            style={{cursor:'pointer'}}
                                                                            data-tooltip-id='viewbetsdetail' data-tooltip-content="View Bets"
                                                                            onClick={()=>{
                                                                                navigate('/match/view-bets' )
                                                                            }} >
                                                                                20
                                                                            </span>
                                                                            <Tooltip id='viewbetsdetail' place="bottom" effect="solid"/>
                                                                    </div>

                                                                    <div className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        <span className="badge badge-info-lighten">20</span>
                                                                    </div>
                                                                    <div className="w-25 text-center m-0 p-2">
                                                                        <span className="badge badge-warning-lighten">15</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* option two */}
                                                    <div className="col-12 col-md-6 mb-2">
                                                        <div className="card w-100 bets-responsive">
                                                            <div className="card-body">
                                                                <div className="d-flex align-items-center justify-content-around">
                                                                    <h5 className="text-center mb-3">
                                                                        Option
                                                                        (12) 
                                                                    </h5>
                                                                </div>
                                                                <div className="d-flex align-items-center justify-content-around"
                                                                    style={{border: "1px solid var(--bs-border-color)",borderBottom:'0px'}}>

                                                                    <h6 className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        Rate(ROI)
                                                                    </h6>
                                                                    <h6 className="w-25 text-center m-0 p-2" style={{ borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        Count
                                                                    </h6>
                                                                    <h6 className="w-25 text-center m-0 p-2"style={{borderRight:"1px solid var(--bs-border-color)", }}>
                                                                        Amount
                                                                    </h6>
                                                                    <h6 className="w-25 text-center m-0 p-2">
                                                                        Percentage
                                                                    </h6>
                                                                    
                                                                </div>
                                                                <div className="d-flex align-items-center justify-content-around"style={{border: "1px solid var(--bs-border-color)",}}>
                                                                    <div className="w-25 text-center m-0 p-2" style={{ borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        <span className="badge badge-danger-lighten">(22)</span>
                                                                    </div>
                                                                    
                                                                    <div className="w-25 text-center m-0 p-2"
                                                                        style={{borderRight:"1px solid var(--bs-border-color)"}}
                                                                    >
                                                                        <span 
                                                                            data-tooltip-id='viewbetsdetail' data-tooltip-content="View Bets"
                                                                            style={{cursor:'pointer' }}
                                                                            className="badge badge-primary-lighten" 
                                                                            >
                                                                                32
                                                                            </span>
                                                                            <Tooltip id='viewbetsdetail' place="bottom" effect="solid"/>
                                                                    </div>

                                                                    <div className="w-25 text-center m-0 p-2"style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                        <span className="badge badge-info-lighten">33</span>
                                                                    </div>
                                                                    <div className="w-25 text-center m-0 p-2">
                                                                        <span className="badge badge-warning-lighten">34</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div> 
                                    </>
                                     
                                    

                                    {/* second card remove when calling API */} 
                                        <> 
                                            <div
                                                className="card mb-4" 
                                            >
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                        <table className="table w-100 mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>SN</th>
                                                                    <th>Category</th>
                                                                    <th>Question Type</th>
                                                                    <th>State</th>
                                                                    <th className="text-nowrap">Option Type</th>
                                                                    <th>Result</th>
                                                                    <th>Status</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody> 
                                                                    <tr>
                                                                    <td>2</td>
                                                                    <td>1x2</td>
                                                                    <td>match win</td>
                                                                    <td>
                                                                        <span className="badge badge-info-lighten"> 
                                                                            INREVIEW
                                                                        </span>
                                                                    </td>
                                                                    <td>team a / team b</td>
                                                                    <td>
                                                                        <span className="badge badge-warning-lighten"> 
                                                                            instant
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge badge-success-lighten"> 
                                                                            ACTIVE
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center justify-content-center"> 

                                                                            <button
                                                                                type="button"
                                                                                data-tooltip-id="publish"
                                                                                data-tooltip-content="Publish Bet"
                                                                                className="btn bg-primary text-white d-flex me-2 py-0 px-1 fs-6"
                                                                                style={{ float: "right" }} 
                                                                            >
                                                                                Publish
                                                                            </button>
                                                                            <Tooltip
                                                                                id="publish"
                                                                                place="bottom"
                                                                                effect="solid"
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    
                                                    <div className="mt-3">
                                                        <div className="mb-3">
                                                            <strong> Question :{" "}</strong>
                                                            <span>
                                                                Who will win the match ? 
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row d-flex align-items-center justify-content-center">
                                                        {/* option one */}
                                                        <div className="col-12 col-md-6 mb-2">
                                                            <div className="card w-100 bets-responsive">
                                                                <div className="card-body">
                                                                    <div className="d-flex align-items-center justify-content-around">
                                                                        <h5 className="text-center mb-3">
                                                                            Option 
                                                                            (India) 
                                                                        </h5>
                                                                    </div>

                                                                    <div className="d-flex align-items-center justify-content-around"
                                                                        style={{ border: "1px solid var(--bs-border-color)", borderBottom:'0px' }} >
                                                                        <h6 className="w-25 text-center m-0 p-2"  style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                            Rate ( ROI )
                                                                        </h6>
                                                                        <h6 className="w-25 text-center m-0 p-2" style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                            Count
                                                                        </h6>
                                                                        <h6  className="w-25 text-center m-0 p-2"  style={{ borderRight: "1px solid var(--bs-border-color)", }} >
                                                                            Amount
                                                                        </h6>
                                                                        <h6 className="w-25 text-center m-0 p-2">
                                                                            Percentage
                                                                        </h6>
                                                                    </div>

                                                                    <div className="d-flex align-items-center justify-content-around"
                                                                        style={{ border: "1px solid var(--bs-border-color)", }} >

                                                                        <div className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            <span className="badge badge-danger-lighten">2.2</span>
                                                                        </div>

                                                                        <div className="w-25 text-center m-0 p-2"
                                                                            style={{borderRight:"1px solid var(--bs-border-color"}}
                                                                            >
                                                                            <span className="badge badge-primary-lighten"
                                                                                style={{cursor:'pointer'}}
                                                                                data-tooltip-id='viewbetsdetail' data-tooltip-content="View Bets"
                                                                                onClick={()=>{
                                                                                    navigate('/match/view-bets' )
                                                                                }} >
                                                                                    20
                                                                                </span>
                                                                                <Tooltip id='viewbetsdetail' place="bottom" effect="solid"/>
                                                                        </div>

                                                                        <div className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            <span className="badge badge-info-lighten">20</span>
                                                                        </div>
                                                                        <div className="w-25 text-center m-0 p-2">
                                                                            <span className="badge badge-warning-lighten">15</span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* option two */}
                                                        <div className="col-12 col-md-6 mb-2">
                                                            <div className="card w-100 bets-responsive">
                                                                <div className="card-body">
                                                                    <div className="d-flex align-items-center justify-content-around">
                                                                        <h5 className="text-center mb-3">
                                                                            Option
                                                                            (12) 
                                                                        </h5>
                                                                    </div>
                                                                    <div className="d-flex align-items-center justify-content-around"
                                                                        style={{border: "1px solid var(--bs-border-color)",borderBottom:'0px'}}>

                                                                        <h6 className="w-25 text-center m-0 p-2" style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            Rate(ROI)
                                                                        </h6>
                                                                        <h6 className="w-25 text-center m-0 p-2" style={{ borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            Count
                                                                        </h6>
                                                                        <h6 className="w-25 text-center m-0 p-2"style={{borderRight:"1px solid var(--bs-border-color)", }}>
                                                                            Amount
                                                                        </h6>
                                                                        <h6 className="w-25 text-center m-0 p-2">
                                                                            Percentage
                                                                        </h6>
                                                                        
                                                                    </div>
                                                                    <div className="d-flex align-items-center justify-content-around"style={{border: "1px solid var(--bs-border-color)",}}>
                                                                        <div className="w-25 text-center m-0 p-2" style={{ borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            <span className="badge badge-danger-lighten">(22)</span>
                                                                        </div>
                                                                        
                                                                        <div className="w-25 text-center m-0 p-2"
                                                                            style={{borderRight:"1px solid var(--bs-border-color)"}}
                                                                        >
                                                                            <span 
                                                                                data-tooltip-id='viewbetsdetail' data-tooltip-content="View Bets"
                                                                                style={{cursor:'pointer' }}
                                                                                className="badge badge-primary-lighten" 
                                                                                >
                                                                                    32
                                                                                </span>
                                                                                <Tooltip id='viewbetsdetail' place="bottom" effect="solid"/>
                                                                        </div>

                                                                        <div className="w-25 text-center m-0 p-2"style={{borderRight:"1px solid var(--bs-border-color)",}}>
                                                                            <span className="badge badge-info-lighten">33</span>
                                                                        </div>
                                                                        <div className="w-25 text-center m-0 p-2">
                                                                            <span className="badge badge-warning-lighten">34</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                </div>
                                            </div> 
                                        </>
                                     
                                    {/* second card remove when calling API */}




                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Bets;